<iframe [src]="url | safe" frameborder="0" allowfullscreen="true" scrolling="no" width="100%" height="400"></iframe>
